import { render } from "./ImpressionWidget.vue?vue&type=template&id=c5cf1ed4"
import script from "./ImpressionWidget.vue?vue&type=script&lang=js"
export * from "./ImpressionWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__